import React, {useState, useEffect} from 'react'
import Loading from '../general/Loading';
import '../css/components/PurchaseHistory.css';
import { useNavigate } from 'react-router-dom'

const PurchaseHistory = ({setResponse}) => {
    const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
    const [purchase, setPurchase] = useState([]);
    const [showItem, setShowItem] = useState(false);
    const [selectedBill, setSelectedBill] = useState('');
    const [showDue, setShowDue] = useState(false);
  const [formData, setFormData] = useState({
    amount_received: '',
  })
        const [searchQuery, setSearchQuery] = useState('');


useEffect(() => {
  const fetchPurchase = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.siddhabhairabistore.com/get-purchase-bill');

      if (response.ok) {
        const data = await response.json();
        console.log(data);

        // Sort by date (latest first)
        const sortedData = data.sort((a, b) => new Date(b.date) - new Date(a.date));
        setPurchase(sortedData);
      } else {
        console.error('Failed to fetch purchase');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  fetchPurchase();
}, []);


const handleShowItem = (product) => {
  setSelectedBill(product);
  setShowItem(true);
}

const handleAddToStock = async (bill) => {
  try {
    const payload = {
      items: bill.items.map(item => ({
        itemId: item.itemId || item.id,
        quantity: item.quantity
      }))
    };

    const response = await fetch(`https://api.siddhabhairabistore.com/add-purchase-item/${bill.id}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const result = await response.json();

    if (response.ok) {
      setResponse({ message: 'Item Added Successfully.', status: 'success' });
      setTimeout(() => {setResponse('');       window.location.reload()}, 2000);

      setPurchase(prev => prev.map(p => p.id === bill.id ? { ...p, item_added: 1 } : p));
    } else {
      setResponse({ message: result.message || 'Unable to Add Item.', status: 'error' });
      setTimeout(() => setResponse(''), 2000);
    }

  } catch (error) {
    console.error('Error updating stock:', error);
  }
};

const handleShowDue = (product) => {
  setSelectedBill(product);
  setShowDue(true);
}

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value
    });
  };


    const handleUpdateAmount = async (e) => {
    e.preventDefault();
    setLoading(true);

    const newAmountReceived = parseFloat(selectedBill.amount_paid) + parseFloat(formData.amount_received);

    try {
      const response = await fetch(`https://api.siddhabhairabistore.com/update-due/${selectedBill.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          amount_received: newAmountReceived,
        }),
      });

      setLoading(false);
      if (response.ok) {
              setResponse({ message: 'Due Amount updated Successfully.', status: 'success' });

        setPurchase(prevPayData =>
          prevPayData.map(payData =>
            payData.id === selectedBill.id
              ? { ...payData, amount_paid: newAmountReceived }
              : payData
          )
        );
        setTimeout(() => {
          setResponse('');
        }, 2000);
        setFormData({
          amount_received: '',
        })
        setShowDue(false);
      } else {
        setLoading(false);
                      setResponse({ message: 'Unable to update Due Amount.', status: 'success' });
        setTimeout(() => {
          setResponse('');
        }, 2000);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error updating payment:', error);
    }
  };


const formatDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
};


const filterPurchase = purchase.filter(myItem =>
    (myItem.id?.toString().toLowerCase().includes(searchQuery.toLowerCase()) || 
   myItem.party_name?.toLowerCase().includes(searchQuery.toLowerCase()))
);


  return (
    <>
          <section className='my-4'>
      <div className='px-4'>
        <div className='d-flex justify-content-between'>
          <p className='page-title'>Purchase History</p>
          <button className='edit-btn' onClick={() => navigate('/add-purchase')}>Add Purchase</button>
        </div>


                    <div className='d-flex bg-white rounded-2 py-2 my-3'>
                        <i class="fa-solid fa-magnifying-glass text-darkblue px-2"></i>
                        <input
                            type="text"
                            className="profile-control rounded-2 border-0 bg-white w-100 py-0"
                            placeholder="Search By Invoice No, Party Name"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>

        <div className='table-responsive bg-white rounded-2 px-3 py-3'>
          <table className='w-100'>
              <tr className='inventory-row d-flex'>
                <th style={{flex: 0.3}}>Inv No</th>
                <th style={{flex: 0.3}}>Date</th>
                <th style={{flex: 1}}>Party Name</th>
                <th style={{flex: 0.6}}>Total Amount</th>
                {/* <th style={{flex: 0.6}}>Amount Paid</th> */}
                <th className='d-md-block d-none' style={{flex: 0.6}}>Amount Paid</th>
                <th style={{flex: 0.3}}>Activity</th>
              </tr>

              {filterPurchase.map(product => (
                <tr key={product.id} className='inventory-row d-flex my-2'>
                  <td style={{flex: 0.3}}>{product.id}</td>
                <td style={{flex: 0.3}}>{formatDate(product.date)}</td>
                  <td style={{flex: 1}}>{product.party_name}</td>
                  <td style={{flex: 0.6}}>₹{product.total_amount}</td>
                  {/* <td style={{flex: 0.6}}>₹{product.amount_paid}</td> */}
                  <td style={{flex: 0.6}} className='text-success d-md-block d-none'>₹{product.amount_paid}</td>
                  <td style={{flex: 0.3}} className='fs-5'>{product.item_added == '0' ? 
                    <span onClick={() => handleAddToStock(product)}><i class="fa-solid fa-plus-circle cursor-pointer"></i></span> : 
                  <span onClick={() => {setResponse({ message: 'Item already added to Stock.', status: 'success' }); setTimeout(() => setResponse(''), 2000);}}><i class="fa-solid fa-circle-check cursor-pointer"></i></span>}
                  <span className='mx-2' onClick={() => handleShowItem(product)}><i class="fa-solid fa-eye cursor-pointer"></i></span>
                  {product.total_amount != product.amount_paid && (
<span onClick={() => handleShowDue(product)}><i class="fa-solid fa-pen-to-square cursor-pointer"></i></span>
                  )}
                  
                  </td>
                </tr>
              ))}

</table>
</div>

</div>
</section>

      {loading && <Loading setLoading={setLoading} />}

{showItem && (
  <>
  <section className='bill-area'>
    <div className='bill-inner col-lg-6 col-10 mx-auto'>

<p className='category-text'>Bill Details</p>
{/* <hr /> */}

<p className='para-text'>Invoice No: {selectedBill.id}<br />Party Name: {selectedBill.party_name}</p>

<p className='my-0 fw-semibold'>Purchased Items</p>
<p className='para-text'>
  {selectedBill.items && selectedBill.items.length > 0
    ? selectedBill.items.map(item => `${item.name} (x${item.quantity})`).join(', ')
    : 'No items'}
</p>

<p className='para-text'>Total Amount: ₹{selectedBill.total_amount}<br />
<span className='text-success'>Amount Paid: ₹{selectedBill.amount_paid}</span>
<br /><span className='text-danger'>Due Amount: ₹{selectedBill.total_amount - selectedBill.amount_paid}<br /><br /></span>Payment Method: {selectedBill.pay_method}</p>

<button className='close-btn' onClick={() => setShowItem(false)}>Close</button>

    </div>
  </section>
  </>
)}

{showDue && (
  <>
  <section className='bill-area'>
    <div className='bill-inner col-lg-4 col-10 mx-auto'>

<p className='page-title'>Manage Dues</p>

<p>Inv No: {selectedBill.id}<br />
  <span className='text-danger'>Due Amount: ₹{selectedBill.total_amount - selectedBill.amount_paid}</span>
</p>


              <form className="row g-3 bg-white rounded-4 mb-4" onSubmit={handleUpdateAmount}>
                {/* Product Name */}

                <div className="col-12">
                  <label htmlFor="amount_received" className="profile-label">Amount Received</label>
                  <input
                    type="text"
                    className="product-control"
                    id="amount_received"
                    value={formData.amount_received}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className='col-12'>
                  <button className='close-btn' onClick={() => setShowDue(false)}>Close</button>&nbsp;&nbsp;
                  <button className='edit-btn'>Update</button>
                </div>

              </form>



    </div>
  </section>
  </>
)}
    </>
  )
}

export default PurchaseHistory
